import React from "react";
import { LazyLoadImages } from "@quintype/components";

import { HomePage as HomePageBase } from "../components/pages/home";
import { SectionPage as SectionPageBase } from "../components/pages/section";
import { TagPage as TagPageBase } from "../components/pages/tag";
import { AuthorPage as AuthorPageBase } from "../components/pages/author";
import { SearchPage as SearchPageBase } from "../components/pages/search";
import { CatalogPage as CatalogPageBase } from "../components/pages/catalog";
import { HomePagePreview as HomePagePreviewBase } from "../components/pages/home-preview";
import { NotFoundPage as NotFoundPageBase } from "../components/pages/not-found";
import { BundlePage as BundlePageBase } from "../components/pages/bundle";
import { MagazineLandingPage as MagazineLandingPageBase } from "../components/pages/magazine-landing";
import { MagazineIssueListingPage as MagazineIssueListingPageBase } from "../components/pages/magazine-listing-page";
import { MagazineSearchArchivePage as MagazineSearchArchivePageBase } from "../components/pages/magazine-archive-page";
import { DfpAd } from "../../isomorphic/components/atoms/dfp-ad";

function wrapLazyLoadImages(Template) {
  const ImageLazyLoadedComponent = props => {
    return (
      <React.Fragment>
        <DfpAd adtype="Automated" placement="all" />
        <DfpAd adtype="Large_Leaderboard" placement="all" />
        <LazyLoadImages margin={"150px"}>
          <Template {...props} />
        </LazyLoadImages>
      </React.Fragment>
    );
  };
  ImageLazyLoadedComponent.displayName = `WrapLazyLoadImages(${Template.name})`;
  return ImageLazyLoadedComponent;
}

export const HomePage = wrapLazyLoadImages(HomePageBase);
export const SectionPage = wrapLazyLoadImages(SectionPageBase);
export const TagPage = wrapLazyLoadImages(TagPageBase);
export const AuthorPage = wrapLazyLoadImages(AuthorPageBase);
export const SearchPage = wrapLazyLoadImages(SearchPageBase);
export const CatalogPage = wrapLazyLoadImages(CatalogPageBase);
export const HomePagePreview = wrapLazyLoadImages(HomePagePreviewBase);
export const NotFoundPage = wrapLazyLoadImages(NotFoundPageBase);
export const BundlePage = wrapLazyLoadImages(BundlePageBase);
export const MagazineLandingPage = wrapLazyLoadImages(MagazineLandingPageBase);
export const MagazineIssueListingPage = wrapLazyLoadImages(MagazineIssueListingPageBase);
export const MagazineSearchArchivePage = wrapLazyLoadImages(MagazineSearchArchivePageBase);
